/** How the reader reached the next listing: the page turned itself, or they took it. */
export type NextTurnTrigger = 'auto' | 'click';

/** The detail page the turn leaves, reported as the event's `Source`. */
export type NextTurnSurface = 'product' | 'project' | 'article';

/**
 * The `NextProductTurn` / `NextProjectTurn` / `NextArticleTurn` payload, the
 * same for every control that turns to the next listing (the growing section,
 * its link, the island's pill).
 *
 * `NextLink` and `Trigger` are not columns the warehouse flattening keeps, so
 * on their own an automatic turn could not be told from a deliberate one.
 * `Source` carries the surface and `ExtraData` the rest.
 */
export const nextTurnData = (
    surface: NextTurnSurface,
    nextLink: string,
    trigger: NextTurnTrigger,
) => ({
    NextLink: nextLink,
    Trigger: trigger,
    Source: surface,
    ExtraData: JSON.stringify({ nextLink, trigger }),
});
